import { Button } from '@life-line-lab/components-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Statuses } from 'Types/common.types'
import { FetchedUserData } from 'Types/user.types'

interface TabFooterProps {
    canEdit:boolean,
    canDelete:boolean,
    handleEdit?:()=>void,
    handleSetModal:(action:Statuses)=>void,
    userDetails:FetchedUserData,
}

const TabFooter:React.FC<TabFooterProps> = ({
    canEdit,
    canDelete,
    handleEdit,
    handleSetModal,
    userDetails,
}) => {

    const { t } = useTranslation();

    return (
        <div>
            {
                (userDetails?.userRole?.status === "ACTIVE" || userDetails.userRole?.status === "PENDING_ACCOUNT") &&
                (
                    userDetails?.userRole?.approvalStatus === Statuses.PENDING ? 
                    <>
                        {canEdit &&
                            <Button
                                type="primary"
                                className="mr-10"
                                label={t("action.edit")}
                                onClick={() => { handleEdit && handleEdit() }}
                            />
                        }
                    </> :
                    <>
                        {canEdit &&
                            <Button
                                type="primary"
                                className="mr-10"
                                label={t("action.edit")}
                                onClick={() => { handleEdit && handleEdit() }}
                            />
                        }
                        {canDelete &&
                            <Button
                                type="danger"
                                label={t("action.deactivate")}
                                onClick={() => handleSetModal && handleSetModal(Statuses.DEACTIVATE)}
                            />
                        }
                    </>
                )
            }

            {
                userDetails?.userRole?.status === 'DEACTIVATED' &&
                (
                    <>
                        {canEdit &&
                            <Button
                                type="primary"
                                className="mr-10"
                                label={t("action.activate")}
                                onClick={() => {
                                    handleSetModal && handleSetModal(Statuses.ACTIVATE)
                                }}
                            />
                        }
                    </>
                )
            }
        </div>
    )
}

export default TabFooter